import de_DE from '@/data/countries-de-DE.json'
import en_CA from '@/data/countries-en-CA.json'
import en_GB from '@/data/countries-en-GB.json'
import en_US from '@/data/countries-en-US.json'
import es_ES from '@/data/countries-es-ES.json'
import fr_FR from '@/data/countries-fr-FR.json'
import it_IT from '@/data/countries-it-IT.json'
import ja_JP from '@/data/countries-ja-JP.json'
import ko_KR from '@/data/countries-ko-KR.json'
import nl_BE from '@/data/countries-nl-BE.json'
import zh_CN from '@/data/countries-zh-CN.json'
import zh_TW from '@/data/countries-zh-TW.json'

export default { de_DE, en_CA, en_GB, en_US, es_ES, fr_FR, it_IT, ja_JP, ko_KR, nl_BE, zh_CN, zh_TW }
